import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export const Navbar = () => {
  const [showNavButtons, setShowNavButtons] = useState(false);

  const scrollToSection = (name) => {
    const element = document.getElementById(name);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setShowNavButtons(false);
    }
  };

  const Click = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="navbar">
      {/* Brand / Logo */}
      <div className="nav-name">&lt; MRCAPTION49 -  2026 &gt;</div>

      {/* Right-side nav content */}
      <div className="nav-right">
        {/* Resume Button Only */}
        <div className="nav-actions">
          <button
            onClick={() => {
              Click(
                "https://docs.google.com/document/d/1-4PEc96n-rTCTmSV2L84vt00Hztyt72K/edit?usp=sharing&ouid=113363362385209589053&rtpof=true&sd=true"
              );
            }}
            className="resume-btn"
          >
            <i class="fa-regular fa-file"></i>
            <span>Resume</span>
          </button>
        </div>
      </div>

      
    </div>
  );
};

export default Navbar;
